import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faTrophy,
  faClipboardList,
  faCalendarAlt,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

const MobileNavBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    if (path === "/home" && currentPath === "/home") return true;
    if (
      path === "/leagues" &&
      (currentPath === "/leagues" || currentPath.startsWith("/league/"))
    )
      return true;
    if (path === "/events" && currentPath.startsWith("/events")) return true;
    if (
      path === "/globalcompetition" &&
      (currentPath === "/globalcompetition" ||
        currentPath === "/league/events" ||
        currentPath === "/leaderboard")
    )
      return true;
    if (path !== "/" && currentPath.startsWith(path)) return true;
    return false;
  };

  const navItems = [
    {
      path: "/home",
      label: "Home",
      icon: faHome,
    },
    {
      path: "/leagues",
      label: "Leagues",
      icon: faTrophy,
    },
    {
      path: "/scorecard",
      label: "Scorecard",
      icon: faClipboardList,
    },
    {
      path: "/events",
      label: "Events",
      icon: faCalendarAlt,
    },
    {
      path: "/globalcompetition",
      label: "Global",
      icon: faGlobe,
    },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-dark-grey border-t border-white/10 z-50 shadow-lg">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex flex-col items-center justify-center w-full h-full py-2 px-1 touch-manipulation ${
              isActive(item.path)
                ? "text-gold"
                : "text-white/80 hover:text-gold active:text-gold"
            }`}
            aria-label={item.label}
          >
            <FontAwesomeIcon icon={item.icon} className="text-xl mb-1" />
            <span className="text-xs whitespace-nowrap">{item.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MobileNavBar;
